// components/Vehicles.js
import React, { useState, useEffect } from 'react';
import './Vehicles.css';
import axios from 'axios';
import { Link } from 'react-router-dom';
import API_CONFIG2 from '../API_CONFIG2/API_CONFIG2';

const Vehicles = () => {
  const [vehicles, setVehicles] = useState([]);
  const [showShareFeedback, setShowShareFeedback] = useState(false);

  // Charger les véhicules dynamiquement
  useEffect(() => {
    fetchVehicles();
  }, []);

  const fetchVehicles = async () => {
    try {
      const response = await axios.get(`${API_CONFIG2.apiUrl}AllVehicule.php`);
      if (response.data.success) {
        setVehicles(response.data.datas);
      } else {
        alert("Erreur lors du chargement des véhicules");
      }
    } catch (error) {
      console.error("Erreur API:", error);
      alert("Impossible de charger les véhicules");
    }
  };

  const getStatusClass = (statut) => {
    switch (statut) {
      case 'Disponible': return 'status-available';
      case 'En maintenance': return 'status-maintenance';
      case 'Hors service': return 'status-out';
      case 'En location': return 'status-rented';
      default: return 'status-available';
    }
  };

  // Fonction de partage
  const handleShare = async () => {
    const shareUrl = window.location.href;
    
    if (navigator.share) {
      try {
        await navigator.share({
          title: 'Parc Automobile',
          text: 'Découvrez notre parc automobile de qualité',
          url: shareUrl,
        });
      } catch (error) {
        console.log('Erreur de partage:', error);
      }
    } else {
      // Fallback pour copier dans le presse-papier
      try {
        await navigator.clipboard.writeText(shareUrl);
        setShowShareFeedback(true);
        setTimeout(() => setShowShareFeedback(false), 2000);
      } catch (err) {
        console.error('Erreur de copie:', err);
        // Fallback alternatif
        const textArea = document.createElement('textarea');
        textArea.value = shareUrl;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
        setShowShareFeedback(true);
        setTimeout(() => setShowShareFeedback(false), 2000);
      }
    }
  };

  // Composant de particules amélioré
  const ParticlesBackground = () => (
    <div className="particles-background">
      {[...Array(15)].map((_, i) => (
        <div 
          key={i}
          className="particle" 
          style={{
            '--i': i,
            '--random-x': Math.random() * 100,
            '--random-y': Math.random() * 100,
            '--random-size': Math.random() * 3 + 1,
            '--random-duration': Math.random() * 20 + 10,
            '--random-delay': Math.random() * -20
          }}
        />
      ))}
    </div>
  );

  return (
    <div className="vehicles-container">
      <ParticlesBackground />
      
      <div className="vehicles-header">
        <h1 className='text-white'>Parc automobile</h1>
      </div>

      {/* Bouton de partage rond */}
      <button 
        className={`share-btn ${showShareFeedback ? 'share-success' : ''}`}
        onClick={handleShare}
        aria-label="Partager cette page"
      >
        <svg className="share-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
                d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z" />
        </svg>
        
        {showShareFeedback && (
          <span className="share-feedback">Lien copié !</span>
        )}
      </button>

      <div className="vehicles-grid">
        {vehicles.map(vehicle => (
          <div key={vehicle.id} className="vehicle-card">
            <div className="vehicle-image">
              <Link to={`/InfoCar/${vehicle.id}`}>
                <img 
                  src={`${API_CONFIG2.apiUrl}carpic/${vehicle.image1}`} 
                  alt={`${vehicle.marque} ${vehicle.modele}`} 
                  loading="lazy"
                />
                <div className={`vehicle-status ${getStatusClass(vehicle.statut)}`}>
                  {vehicle.statut}
                </div>
              </Link>
            </div>
            <div className="vehicle-info">
              <h3 className="vehicle-name">{vehicle.marque} {vehicle.modele}</h3>
              <p className="vehicle-year">{vehicle.annee}</p>
              <div className="vehicle-details">
                <div className="detail-item">
                  <span className="detail-label">Immatriculation</span>
                  <span className="detail-value">{vehicle.immatriculation}</span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">Carburant</span>
                  <span className="detail-value">{vehicle.carburant}</span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">Kilométrage</span>
                  <span className="detail-value">{vehicle.kilometrage} km</span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">Prix</span>
                  <span className="detail-value">{vehicle.prix} $</span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Vehicles;